module.exports = __webpack_public_path__ + "img/777da91.svg";